/**
 * Application settings and configuration values
 */

// GraphQL and Auth endpoints
export const GRAPHQL_ENDPOINT = import.meta.env.VITE_GRAPHQL_ENDPOINT
export const AUTH_ENDPOINT = import.meta.env.VITE_AUTH_ENDPOINT

/** Base URL for REST API (e.g. for /safetyculture/templates). Derived from GraphQL endpoint origin. */
export function getApiBaseUrl(): string {
  try {
    return new URL(GRAPHQL_ENDPOINT || '').origin
  } catch {
    return ''
  }
}
export const FIREBASE_TENANT_ID = import.meta.env.VITE_FIREBASE_TENANT_ID

// Firebase configuration
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Mapbox endpoints
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN
export const MAPBOX_GEOCODING_ENDPOINT = 'https://api.mapbox.com/geocoding/v5/mapbox.places'
export const MAPBOX_DIRECTIONS_ENDPOINT = 'https://api.mapbox.com/directions/v5/mapbox/driving'
export const VEHICLE_IMAGE_ENDPOINT = 'https://cdn.imagin.studio/getimage'

// Map settings
export const MAP_CENTER: [number, number] = [18.0686, 59.3293] // Stockholm coordinates
export const MAP_ZOOM = 10
export const MAP_STYLE = 'mapbox://styles/mapbox/streets-v12'

// Storage keys
export const EVENTS_STORAGE_KEY = 'logistics-map-state'
export const USER_PROFILE_STORAGE_KEY = 'user-profile-data'

// API Keys

// UI settings
export const MOBILE_BREAKPOINT = 768
export const DESKTOP_BREAKPOINT = 1024
// Add other configuration values here as needed
